import { gql } from '@apollo/client';

export const GET_ENVIRONMENT_CONFIG = gql`
  query GetEnvironmentConfig {
    environmentConfig {
      siteName
      siteDomain
      siteTagline
      contactEmail
      supportEmail
      paywallEnabled
    }
  }
`;

export interface EnvironmentConfig {
  siteName: string;
  siteDomain: string;
  siteTagline: string;
  contactEmail: string;
  supportEmail: string;
  paywallEnabled: boolean;
}

export interface EnvironmentConfigData {
  environmentConfig: EnvironmentConfig;
}
